/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClean = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m7 3.176 1.118 1.706L9.824 6 8.118 7.118 7 8.824 5.882 7.118 4.176 6l1.706-1.118zm8 1 2.702 4.122L21.824 11l-4.122 2.702L15 17.824l-2.702-4.122L8.176 11l4.122-2.702zm0 3.648-1.258 1.918L11.824 11l1.918 1.258L15 14.176l1.258-1.918L18.176 11l-1.918-1.258zm-8 4.352 1.91 2.914L11.824 17 8.91 18.91 7 21.824 5.09 18.91 2.176 17l2.914-1.91zm0 3.648-.466.71-.71.466.71.466.466.71.466-.71.71-.466-.71-.466z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgClean as Clean };
